/**
 * Main component for the player.
 *
 * @stable
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'zef-app',
  templateUrl: './zef.component.html',
  styleUrls: ['./zef.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ZefApp {}
